import React from 'react';

import Conditional from '../../../common/conditional';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import classNames from '../pdf.module.scss';
import * as models from '../../../../utils/models';

interface CoverSheetProps {
	overviewData: models.CoverDataOverview[];
	referenceDocuments: models.CoverDataItem[];
	standardCriteriaItems: models.CoverDataItem[];
	note?: string;
	testResult?: string;
}

const CoverSheet: React.FC<CoverSheetProps> = (props) => {
	const GridItem = (params: models.CoverDataItem): JSX.Element => {
		return (
			<div className="row">
				<div className={classNames.grid + ' col'}>{params.label}</div>
				<div className={classNames.grid + ' col'}>{params.value}</div>
			</div>
		);
	};

	return (
		<div className="p-2">
			<Conditional isVisible={!!props.testResult}>
				<div className={classNames.gridNote}>
					TEST RESULT: {props.testResult}
				</div>
			</Conditional>

			<div className="border-dark">
				<PDFTablePage columns={overviewColumns} data={props.overviewData} />
			</div>

			<Conditional isVisible={!!props.note}>
				<div className={classNames.gridNote}>{props.note}</div>
			</Conditional>

			<div className="my-3">
				<div className={classNames.gridTitle}>
					Reference Documents/Work Instruction
				</div>

				<div className="border-dark container-fluid overflow-hidden">
					{props.referenceDocuments.map((item: models.CoverDataItem) => (
						<GridItem key={item.label} label={item.label} value={item.value} />
					))}
				</div>
			</div>

			<Conditional isVisible={props.standardCriteriaItems.length > 0}>
				<div className="my-3">
					<div className={classNames.gridTitle}>Standard / Criteria</div>

					<div className="border-dark container-fluid overflow-hidden">
						{props.standardCriteriaItems.map((item: models.CoverDataItem) => (
							<GridItem
								key={item.label}
								label={item.label}
								value={item.value}
							/>
						))}
					</div>
				</div>
			</Conditional>
		</div>
	);
};

const overviewColumns: models.Column[] = [
	{
		path: 'report',
		label: 'Inspection Report',
		style: () => getColumnStyle(),
	},
	{ path: 'required', label: 'Required (Yes/No)' },
	{ path: 'page', label: 'Page' },
];

const getColumnStyle = (): React.CSSProperties => {
	return { textAlign: 'left' };
};

export default CoverSheet;
